export default {
  "nav": {
    "home": "Nyumbani",
    "menu": "Menyu",
    "mobile_app": "Programu ya Simu",
    "contact_us": "Wasiliana Nasi",
    "sign_in": "Ingia",
    "cart": "Kikapu",
    "logout": "Toka",
    "profile": "Wasifu",
    "orders": "Agizo",
    "notifications": "Arifa",
    "no_address_found": "Hakuna anwani iliyopatikana"
  },
  "header": {
    "title": "Chakula Kitamu, Kinapoletwa Haraka",
    "description": "Unganisha na migahawa bora ya mtaani na furahia vyakula vyako vinavyopendelea vikiletwa hadi mlangoni mwako. DASHBASKET inakupatia ladha za asili na huduma ya kipekee, ikifanya kila mlo kuwa maalum bila kutoka nyumbani.",
    "greeting": "Hujambo, {{name}}",
    "there": "huko"
  },
  "buttons": {
    "add_to_cart": "Ongeza kwenye Kikapu",
    "remove_from_cart": "Ondoa kwenye Kikapu",
    "place_order": "Weka Agizo",
    "proceed_to_checkout": "Endelea Kulipa",
    "continue_shopping": "Endelea Kununua",
    "view_cart": "Angalia Kikapu",
    "update": "Sasisha",
    "save": "Hifadhi",
    "cancel": "Ghairi",
    "confirm": "Thibitisha",
    "back": "Rudi",
    "next": "Ifuatayo",
    "submit": "Wasilisha",
    "search": "Tafuta",
    "filter": "Chuja",
    "apply": "Tumia",
    "reset": "Rudisha",
    "edit": "Hariri",
    "delete": "Futa",
    "view": "Angalia"
  },
  "food": {
    "popular_dishes": "Vyakula Maarufu",
    "new_arrivals": "Vyakula Vipya",
    "recommended": "Vinapendekezwa",
    "vegetarian": "Vyakula vya Mimea",
    "vegan": "Vyakula vya Vegan",
    "gluten_free": "Bila Gluten",
    "spicy": "Kali",
    "price": "Bei",
    "ingredients": "Viungo",
    "nutrition_info": "Maelezo ya Lishe",
    "calories": "Kalori",
    "add_special_instructions": "Ongeza maelekezo maalum",
    "out_of_stock": "Haipatikani",
    "food_item": "Chakula",
    "unnamed_item": "Chakula bila jina",
    "no_description": "Hakuna maelezo yaliyopatikana"
  },
  "footer": {
    "about_us": "Kuhusu Sisi",
    "privacy_policy": "Sera ya Faragha",
    "terms_of_service": "Masharti ya Huduma",
    "help_center": "Kituo cha Msaada",
    "contact": "Wasiliana",
    "follow_us": "Tufuate",
    "download_app": "Pakua programu yetu",
    "all_rights_reserved": "Haki zote zimehifadhiwa",
    "google_play_store": "Google Play Store",
    "apple_app_store": "Apple App Store",
    "links": "Viungo",
    "services": "Huduma",
    "apply_as_restaurant": "Omba kama Mgahawa",
    "apply_as_driver": "Omba kama Dereva",
    "information": "Maelezo",
    "support": "Msaada",
    "powered_by": "Inaendeshwa na"
  },
  "restaurants": {
    "closed": "Mgahawa Umefungwa",
    "search_placeholder": "Tafuta magahawa...",
    "filters": {
      "delivery_fee": "Ada ya Uwasilishaji",
      "all_delivery_fees": "Ada Zote za Uwasilishaji",
      "free_delivery": "Uwasilishaji wa Bure",
      "under_2000_bif": "Chini ya 2000 BIF",
      "under_3000_bif": "Chini ya 3000 BIF",
      "all_cuisines": "Vyakula Vyote",
      "all_prices": "Bei Zote",
      "all_ratings": "Makadirio Yote",
      "stars": "nyota",
      "under_40_min": "Chini ya dakika 40",
      "open_now": "Wazi Sasa",
      "closing_soon": "Kufunga Hivi Karibuni",
      "no_restaurants_found": "Hakuna mgahawa uliopatikana unaofanana na vigezo vyako.",
      "clear_all_filters": "Futa vichujio vyote",
      "calculating_delivery_fee": "Inakokotoa ada ya uwasilishaji...",
      "delivery_fee_unavailable": "Ada ya uwasilishaji: --",
      "no_reviews_yet": "Hakuna hakiki bado",
      "new": "Mpya",
      "km_away": "Km kutoka"
    }
  },
  "cart": {
    "title": "Kikapu Changu",
    "confirm_clear_all": "Una uhakika unataka kufuta vikapu vyote?",
    "share_cart_details": "Shiriki maelezo ya kikapu",
    "cart_cleared": "Kikapu kimefutwa kwa mafanikio",
    "failed_to_clear_cart": "Imeshindwa kufuta kikapu",
    "failed_to_share_cart": "Imeshindwa kushiriki kikapu",
    "cart_shared": "Kikapu kimeshirikiwa kwa mafanikio",
    "no_items": "Hakuna vitu kwenye kikapu",
    "subtotal": "Jumla ya Sehemu",
    "delivery_fee": "Ada ya Uwasilishaji",
    "total": "Jumla",
    "clear_cart": "Futa Kikapu",
    "share_cart": "Shiriki Kikapu",
    "proceed_to_order": "Endelea kwa Agizo",
    "loading": "Inapakia kikapu...",
    "error_loading": "Hitilafu ya kupakia kikapu",
    "items": "vitu",
    "item": "kitu",
    "continue_shopping": "Endelea Kununua",
    "checkout": "Malipo",
    "add_more_items": "Ongeza vitu zaidi",
    "share_fallback_error": "Imeshindwa kushiriki kikapu. Tafadhali jaribu kunakili kiungo kwa mkono.",
    "share_failed_error": "Imeshindwa kushiriki kikapu. Tafadhali jaribu tena.",
    "share_url_copied": "Kiungo cha kikapu kimenakiliwa kwenye clipboard!",
    "empty_title": "Kikapu chako ni tupu",
    "empty_description": "Anza kuongeza chakula cha kupendeza kwenye kikapu chako ili kuweka agizo.",
    "start_shopping": "Anza Kununua",
    "share_modal_description": "Shiriki kikapu hiki na marafiki na familia yako ili waone unachonunua.",
    "copy_link": "Nakili Kiungo",
    "close": "Funga",
    "remove_cart_title": "Ondoa Kikapu",
    "remove_cart_message": "Una uhakika unataka kuondoa kikapu kutoka {{restaurantName}}? Kitendo hiki hakiwezi kurekebishwa.",
    "remove_cart_confirm": "Ondoa Kikapu",
    "remove_cart_cancel": "Weka Kikapu",
    "removing_cart": "Inaondoa..."
  },
  "myOrders": {
    "title": "Agizo Zangu",
    "loading": "Inapakia agizo zako...",
    "refresh": "Onyesha Upya",
    "no_orders": "Hakuna agizo lililopatikana",
    "order_number": "Agizo #",
    "status": "Hali",
    "date": "Tarehe",
    "total": "Jumla",
    "view_details": "Angalia Maelezo",
    "track_order": "Fuatilia Agizo",
    "show_filters": "Onyesha Vichujio",
    "hide_filters": "Ficha Vichujio",
    "all_statuses": "Hali Zote",
    "from_date": "Tarehe ya Kuanzia",
    "to_date": "Tarehe ya Mwisho",
    "apply": "Tumia",
    "reset": "Weka Upya",
    "unable_to_load": "Hawezi kupakia agizo. Tafadhali jaribu tena.",
    "retry": "Jaribu Tena",
    "no_orders_found": "Hakuna Agizo Lililopatikana",
    "no_orders_match_filters": "Hakuna agizo linalofanana na vichujio vyako vya sasa.",
    "clear_filters": "Futa Vichujio",
    "no_orders_yet": "Bado hujaleta agizo lolote.",
    "ready_to_order": "Tayari kwa kuagiza chakula cha kupendeza? Chunguza migahawa yetu na ulete agizo lako la kwanza!",
    "browse_restaurants": "Chunguza Migahawa",
    "track": "Fuatilia",
    "cancel": "Ghairi",
    "items": "Vitu",
    "subtotal": "Jumla ya Sehemu",
    "pickup_fee": "Ada ya Kuchukua",
    "delivery_fee": "Ada ya Uwasilishaji",
    "delivery_address": "Anwani ya Uwasilishaji",
    "name": "Jina",
    "address": "Anwani",
    "phone": "Simu",
    "not_provided": "Haijatolewa",
    "pickup_information": "Maelezo ya Kuchukua",
    "pickup_location": "Mahali pa Kuchukua",
    "restaurant": "Mgahawa",
    "pickup_instructions": "Tafadhali leta kitambulisho halali na uthibitisho wa agizo",
    "restaurant_name": "Jina la Mgahawa",
    "restaurant_address": "Anwani ya Mgahawa",
    "address_not_available": "Anwani haipatikani",
    "not_available": "Haipatikani",
    "payment": "Malipo",
    "payment_status": "Hali ya Malipo",
    "payment_method": "Njia ya Malipo",
    "online_payment": "Malipo ya Mtandaoni",
    "cash_on_delivery": "Pesa Wakati wa Uwasilishaji",
    "pending": "Inasubiri",
    "track_order": "Fuatilia Agizo",
    "cancel_order": "Ghairi Agizo",
    "delivery_confirmation": "Uthibitisho wa Uwasilishaji",
    "photo_taken_by_driver": "Picha iliyochukuliwa na dereva kwenye mahali pa uwasilishaji",
    "cancel_order_title": "Ghairi Agizo",
    "cancel_order_confirm": "Una uhakika unataka kughairi agizo hili?",
    "cancellation_reason": "Sababu ya kughairi (si lazima):",
    "cancellation_placeholder": "Tafadhali toa sababu ya kughairi agizo hili...",
    "confirm_cancellation": "Thibitisha Kughairi",
    "keep_order": "Weka Agizo",
    "processing": "Inachakata..."
  },
  "placeOrder": {
    "invalid_order_details": "Maelezo ya agizo si sahihi. Tafadhali anza upya.",
    "complete_order_first": "Tafadhali kamilisha maelezo ya agizo kwanza",
    "cart_empty": "Kikapu chako ni tupu",
    "afripay_not_available": "Malipo ya Afripay hayapatikani",
    "failed_create_payment": "Imeshindwa kuunda kikao cha malipo",
    "afripay_payment_failed": "Malipo ya Afripay yameshindwa",
    "error_processing_order": "Hitilafu katika kuchakata agizo lako",
    "server_not_responding": "Seva haijibu",
    "error_creating_order": "Hitilafu katika kuunda agizo",
    "order_placed_success": "Agizo limewekwa kwa mafanikio!",
    "failed_place_order": "Imeshindwa kuweka agizo",
    "validation_failed": "Uthibitisho umeshindwa",
    "sign_in_first": "Kuweka agizo, ingia kwanza",
    "loading_order_details": "Inapakia maelezo ya agizo...",
    "review_your_order": "Kagua Agizo Lako",
    "review_order": "Kagua Agizo Lako",
    "order_details": "Maelezo ya Agizo",
    "delivery_order": "Agizo la Uwasilishaji",
    "pickup_order": "Agizo la Kuchukua",
    "items": "Vitu",
    "customer_information": "Maelezo ya Mteja",
    "name": "Jina",
    "email": "Barua Pepe",
    "phone": "Simu",
    "delivery_information": "Maelezo ya Uwasilishaji",
    "instructions": "Maelekezo",
    "edit_order_details": "Hariri Maelezo ya Agizo",
    "payment_method": "Njia ya Malipo",
    "cash_on_delivery": "Pesa Wakati wa Uwasilishaji / Kuchukua",
    "mobile_money_bank_card": "Afripay",
    "order_summary": "Muhtasari wa Agizo",
    "subtotal": "Jumla ya Sehemu",
    "delivery_fee": "Ada ya Uwasilishaji",
    "pickup_fee": "Ada ya Kuchukua",
    "total": "Jumla",
    "processing": "Inachakata...",
    "place_order": "WEKA AGIZO",
    "order_placed_successfully": "Agizo limewekwa kwa mafanikio!",
    "lumicash_payment": "Lumicash (Lumitel)",
    "coming_soon": "Inakuja hivi karibuni"
  },
  "payment": {
    "sign_in_to_complete": "Tafadhali ingia ili kukamilisha malipo",
    "no_order_information": "Hakuna maelezo ya agizo yaliyopatikana",
    "order_placed_success": "Agizo limewekwa kwa mafanikio!",
    "failed_place_order": "Imeshindwa kuweka agizo",
    "failed_create_afripay": "Imeshindwa kuunda malipo ya Afripay",
    "processing_order": "Inachakata agizo lako...",
    "loading": "Inapakia...",
    "complete_payment": "Kamilisha Malipo Yako",
    "order_summary": "Muhtasari wa Agizo",
    "subtotal": "Jumla ya Sehemu",
    "delivery_fee": "Ada ya Uwasilishaji",
    "total": "Jumla",
    "pay_with_afripay": "Lipa na Afripay",
    "redirect_afripay": "Utarudishwa kwenye Afripay ili kukamilisha malipo yako kwa kutumia:",
    "lumicash": "Lumicash",
    "ecocash": "Ecocash",
    "amount_to_pay": "Kiasi cha kulipa",
    "pay_with_afripay_alt": "Lipa na AfriPay",
    "secure_payment": "Malipo yako yanachakatwa kwa usalama na Afripay",
    "payment_not_supported": "Njia ya Malipo Haitekeleziwi",
    "select_valid_payment": "Tafadhali rudi nyuma na uchague njia sahihi ya malipo.",
    "go_back_to_cart": "Rudi kwenye Kikapu"
  },
  "restaurant": {
    "restaurant_not_found": "Mgahawa haujapatikana",
    "failed_to_load": "Imeshindwa kupakia mgahawa",
    "hours_not_available": "Masaa hayapatikani",
    "closed_today": "Imefungwa leo",
    "open": "Wazi",
    "closed": "Imefungwa",
    "closing_soon": "Inafungwa Hivi Karibuni",
    "link_copied": "Kiungo cha mgahawa kimeigwa kwenye clipboard!",
    "login_to_rate": "Tafadhali ingia ili kukadiria mgahawa huu",
    "loading_restaurant": "Inapakia mgahawa...",
    "error": "Hitilafu",
    "hide_info": "Ficha maelezo ya mgahawa",
    "show_info": "Onyesha maelezo ya mgahawa",
    "hide_details": "Ficha Maelezo",
    "show_details": "Onyesha Maelezo",
    "hide": "Ficha",
    "show": "Onyesha",
    "share_restaurant": "Shiriki mgahawa",
    "share": "Shiriki",
    "rate_restaurant": "Kadiria mgahawa",
    "rate": "Kadiria",
    "search_menu": "Tafuta kwenye menyu ya {{name}}...",
    "cuisine": "Aina ya Chakula",
    "price": "Bei",
    "rating": "Kadirio",
    "hours": "Masaa",
    "phone": "Simu",
    "address": "Anwani"
  },
  "orderDetails": {
    "cart_empty": "Kikapu chako ni tupu",
    "failed_calculate_delivery": "Imeshindwa kuhesabu ada ya uwasilishaji",
    "outside_delivery_area": "Mahali ulichochagua ni nje ya eneo letu la uwasilishaji. Tunawasilisha tu ndani ya Bujumbura Mairie.",
    "delivery_info_saved": "Maelezo ya uwasilishaji yamehifadhiwa",
    "customer_info_saved": "Maelezo ya mteja yamehifadhiwa",
    "failed_save_delivery": "Imeshindwa kuhifadhi maelezo ya uwasilishaji",
    "failed_save_customer": "Imeshindwa kuhifadhi maelezo ya mteja",
    "first_name_required": "Jina la kwanza linahitajika",
    "last_name_required": "Jina la mwisho linahitajika",
    "email_required": "Barua pepe inahitajika",
    "phone_required": "Nambari ya simu inahitajika",
    "street_required": "Anwani ya barabara inahitajika",
    "quartier_required": "Quartier inahitajika",
    "city_required": "Jiji linahitajika",
    "state_required": "Jimbo linahitajika",
    "country_required": "Nchi inahitajika",
    "click_map_select": "Tafadhali bofya kwenye ramani ili kuchagua mahali halisi pa uwasilishaji",
    "save_delivery_info": "Tafadhali hifadhi maelezo yako ya uwasilishaji ili kuendelea",
    "fill_required_fields": "Tafadhali jaza sehemu zote zinazohitajika",
    "order_details": "Maelezo ya Agizo",
    "order_type": "Aina ya Agizo",
    "delivery": "Uwasilishaji",
    "pickup": "Kuchukua",
    "customer_information": "Maelezo ya Mteja",
    "first_name": "Jina la Kwanza",
    "last_name": "Jina la Mwisho",
    "email_address": "Anwani ya Barua Pepe",
    "phone_number": "Nambari ya Simu",
    "delivery_information": "Maelezo ya Uwasilishaji",
    "street_address": "Anwani ya Barabara",
    "quartier": "Quartier",
    "city": "Jiji",
    "state": "Jimbo",
    "country": "Nchi",
    "zip_code_optional": "Msimbo wa Posta (Si Lazima)",
    "select_delivery_location": "Chagua Mahali pa Uwasilishaji",
    "hide_map": "Ficha Ramani",
    "show_map": "Onyesha Ramani",
    "location_confirmed": "Mahali pamehakikiwa",
    "delivery_instructions_optional": "Maelekezo ya Uwasilishaji (Si Lazima)",
    "saving": "Inahifadhi...",
    "delivery_info_saved": "Maelezo ya Uwasilishaji Yamehifadhiwa",
    "save_delivery_info": "Hifadhi Maelezo ya Uwasilishaji",
    "estimated_delivery_fee": "Ada ya uwasilishaji inayokadiriwa",
    "order_summary": "Muhtasari wa Agizo",
    "subtotal": "Jumla ya Sehemu",
    "delivery_fee": "Ada ya Uwasilishaji",
    "pickup_fee": "Ada ya Kuchukua",
    "calculating": "Inahesabu...",
    "total": "Jumla",
    "continue_to_payment": "Endelea kwa Malipo"
  },
  "resetPassword": {
    "invalid_or_expired_link": "Kiungo cha kurekebisha si sahihi au kimeisha",
    "failed_send_reset_email": "Imeshindwa kutuma barua pepe ya kurekebisha. Tafadhali jaribu tena.",
    "passwords_not_match": "Nywila hazifanani",
    "password_too_short": "Nywila lazima iwe na herufi angalau 6",
    "password_reset_success": "Nywila imerekebishwa kwa mafanikio! Unaweza sasa kuingia na nywila yako mpya.",
    "failed_reset_password": "Imeshindwa kurekebisha nywila. Tafadhali jaribu tena.",
    "invalid_reset_link": "Kiungo cha Kurekebisha Si Sahihi",
    "link_invalid_expired": "Kiungo cha kurekebisha nywila si sahihi au kimeisha.",
    "back_to_home": "Rudi Nyumbani",
    "reset_password": "Rekebisha Nywila",
    "set_new_password": "Weka Nywila Mpya",
    "enter_email_send_link": "Weka anwani yako ya barua pepe na tutakutumia kiungo cha kurekebisha nywila yako.",
    "enter_new_password": "Weka nywila yako mpya hapa chini.",
    "email_address": "Anwani ya Barua Pepe",
    "enter_email": "Weka barua pepe yako",
    "sending": "Inatuma...",
    "send_reset_link": "Tuma Kiungo cha Kurekebisha",
    "back_to_login": "Rudi kwa Kuingia",
    "new_password": "Nywila Mpya",
    "enter_new_password": "Weka nywila mpya",
    "confirm_new_password": "Thibitisha Nywila Mpya",
    "confirm_new_password_placeholder": "Thibitisha nywila mpya",
    "resetting": "Inarekebisha..."
  },
  "restaurantApply": {
    "file_too_large": "Faili ni kubwa sana. Ukubwa wa juu wa faili ni 5MB. Ukubwa wa faili: {{size}} MB",
    "select_location_map": "Tafadhali chagua mahali pa mgahawa wako kwenye ramani. Hii inahitajika kwa huduma za uwasilishaji.",
    "location_outside_service": "Mahali ulichochagua ni nje ya eneo letu la huduma.",
    "please_provide": "Tafadhali toa:",
    "business_license": "Leseni ya Biashara",
    "business_license_expiry": "Muda wa Leseni ya Biashara",
    "menu_food_license": "Leseni ya Menyu/Chakula",
    "menu_food_license_expiry": "Muda wa Leseni ya Menyu/Chakula",
    "insurance_certificate": "Cheti cha Bima",
    "insurance_certificate_expiry": "Muda wa Cheti cha Bima",
    "application_submitted": "Maombi yamewasilishwa kwa mafanikio! Tutakagua maelezo yako na kukuwasiliana hivi karibuni.",
    "problem_submitting": "Kulikuwa na tatizo katika kuwasilisha maombi yako. Tafadhali jaribu tena baadaye.",
    "become_partner": "Kuwa Mshirika wa Mgahawa",
    "join_network": "Jiunge na mtandao wetu wa migahawa na ufikie wateja zaidi na DASHBASKET!",
    "restaurant_information": "Maelezo ya Mgahawa",
    "restaurant_name": "Jina la Mgahawa*",
    "cuisine_type": "Aina ya Chakula*",
    "cuisine_example": "mfano, Italia, China, Mexico",
    "restaurant_description": "Maelezo ya Mgahawa*",
    "tell_about_restaurant": "Tuambie kuhusu mgahawa wako",
    "website_optional": "Tovuti (ikiwa inapatikana)",
    "website_example": "https://www.mgahawawako.com",
    "own_delivery": "Tuna huduma yetu ya uwasilishaji",
    "contact_information": "Maelezo ya Mawasiliano",
    "owner_manager_name": "Jina la Mmiliki/Msimamizi*",
    "email_address": "Anwani ya Barua Pepe*",
    "phone_number": "Nambari ya Simu*",
    "phone_example": "mfano, +257 79 123456 au 79123456",
    "restaurant_location": "Mahali pa Mgahawa",
    "address_street": "Anwani/Barabara*",
    "quartier": "Quartier*",
    "city": "Jiji*",
    "country": "Nchi*",
    "zip_code": "Msimbo wa Posta",
    "restaurant_location_map": "Mahali pa Mgahawa kwenye Ramani*",
    "required": "Inahitajika:",
    "pin_exact_location": "Weka mahali halisi pa mgahawa wako kwenye ramani. Hii ni muhimu kwa madereva wa uwasilishaji kupata mgahawa wako na kwa huduma zetu za uwasilishaji.",
    "hide_map": "Ficha Ramani",
    "select_location_map": "Chagua Mahali kwenye Ramani *",
    "location_selected": "Mahali pamechaguliwa kwenye ramani",
    "location_selection_required": "Uchaguzi wa mahali unahitajika",
    "required_documents": "Nyaraka Zinazohitajika",
    "upload_required_documents": "Pakua Nyaraka Zinazohitajika*",
    "all_3_documents": "Nyaraka zote 3 zinahitajika:",
    "max_file_size": "Ukubwa wa juu wa faili: 5MB kwa faili. Aina zinazokubalika: PDF, DOC, DOCX, JPG, PNG",
    "business_license_required": "1. Leseni ya Biashara*",
    "expiration_date": "Tarehe ya Mwisho*",
    "menu_food_license_required": "2. Leseni ya Menyu/Chakula*",
    "insurance_certificate_required": "3. Cheti cha Bima*",
    "all_documents_uploaded": "Nyaraka zote zinazohitajika zimepakuliwa",
    "upload_all_documents": "Tafadhali pakua nyaraka zote zinazohitajika",
    "additional_information": "Maelezo Zaidi",
    "other_details": "Maelezo mengine yoyote unayotaka kushiriki",
    "submitting": "Inawasilisha...",
    "submit_application": "Wasilisha Maombi"
  },
  "sharedCart": {
    "invalid_share_link": "Kiungo cha kushiriki si sahihi",
    "cart_not_found": "Kikapu kilichoshirikiwa hakijapatikana au kimeondolewa",
    "failed_load_cart": "Imeshindwa kupakia kikapu kilichoshirikiwa",
    "failed_load_into_carts": "Imeshindwa kupakia kikapu kilichoshirikiwa kwenye vikapu vyako",
    "loading_shared_cart": "Inapakia kikapu kilichoshirikiwa...",
    "unable_load_cart": "Hawezi Kupakia Kikapu Kilichoshirikiwa",
    "go_to_my_carts": "Nenda kwenye Vikapu Vyangu",
    "go_home": "Nenda Nyumbani",
    "cart_not_found_title": "Kikapu Kilichoshirikiwa Hakijapatikana",
    "cart_removed_invalid": "Kikapu hiki kinaweza kuwa kimeondolewa au kiungo si sahihi.",
    "shared_cart": "Kikapu Kilichoshirikiwa",
    "shared_by": "Kimeshirikiwa na",
    "items": "vitu",
    "items_in_cart": "Vitu kwenye kikapu hiki:",
    "cart_empty": "Kikapu hiki ni tupu",
    "qty": "Idadi:",
    "each": "kila moja",
    "total": "Jumla:",
    "visit_restaurant": "Tembelea Mgahawa",
    "loading": "Inapakia...",
    "add_to_my_carts": "Ongeza kwenye Vikapu Vyangu",
    "subtotal": "Jumla ya Sehemu:",
    "delivery_fee": "Ada ya Uwasilishaji:"
  },
  "verify": {
    "verifying_payment": "Inahakiki malipo yako...",
    "order_id_missing": "Kitambulisho cha agizo hakipo kwenye URL. Tafadhali angalia kiungo na jaribu tena.",
    "authentication_required": "Uthibitisho unahitajika. Tafadhali ingia na jaribu tena.",
    "payment_cancelled": "Malipo yalighairiwa. Unaweza kujaribu kuweka agizo tena.",
    "payment_verified": "Malipo yamehakikiwa kwa mafanikio! Inarudisha kwenye agizo zako...",
    "payment_verification_failed": "Uthibitisho wa malipo umeshindwa. Tafadhali wasiliana na msaada.",
    "authentication_failed": "Uthibitisho umeshindwa. Tafadhali ingia tena.",
    "order_not_found": "Agizo halijapatikana. Tafadhali angalia maelezo ya agizo.",
    "verification_failed_contact": "Uthibitisho wa malipo umeshindwa. Tafadhali wasiliana na msaada ikiwa hii inaendelea.",
    "go_back_to_cart": "Rudi kwenye Kikapu",
    "try_again": "Jaribu Tena",
    "view_my_orders": "Angalia Agizo Zangu",
    "processing_payment": "Inachakata Malipo",
    "processing_payment_please_wait": "Tunachakata malipo yako. Tafadhali subiri tunapothibitisha malipo yako na mtoa huduma. Hii inaweza kuchukua hadi dakika 2.",
    "complete_payment_on_phone": "Tafadhali angalia simu yako na ukamilishe malipo ya mobile money ili kuthibitisha agizo lako. Tunasubiri uthibitisho wa malipo...",
    "complete_payment_title": "Kamilisha Malipo kwenye Simu Yako",
    "payment_timeout": "Muda wa uthibitisho wa malipo umeisha. Tafadhali angalia agizo lako au wasiliana na msaada ikiwa malipo yameondolewa.",
    "payment_successful": "Malipo Yamefanikiwa!",
    "payment_failed": "Malipo Yameshindwa",
    "payment_cancelled": "Malipo Yalighairiwa",
    "payment_cancelled_title": "Malipo Yalighairiwa",
    "thank_you_order": "Asante kwa agizo lako! Utapokea barua pepe ya uthibitisho hivi karibuni.",
    "track_order_status": "Unaweza kufuatilia hali ya agizo lako kwenye sehemu ya 'Agizo Zangu'.",
    "track_order_my_orders": "Unaweza kufuatilia hali ya agizo lako kwenye sehemu ya 'Agizo Zangu'.",
    "contact_support_if_issues": "Ikiwa unaendelea kupata matatizo, tafadhali wasiliana na timu yetu ya msaada."
  },
  "driverApply": {
    "file_too_large": "Faili ni kubwa sana. Ukubwa wa juu wa faili ni 5MB. Ukubwa wa faili: {{size}} MB",
    "please_provide": "Tafadhali toa:",
    "drivers_license": "Leseni ya Kuendesha",
    "drivers_license_expiry": "Muda wa Leseni ya Kuendesha",
    "vehicle_insurance": "Bima ya Gari",
    "vehicle_insurance_expiry": "Muda wa Bima ya Gari",
    "vehicle_registration": "Usajili wa Gari",
    "vehicle_registration_expiry": "Muda wa Usajili wa Gari",
    "application_submitted": "Maombi yamewasilishwa kwa mafanikio! Tutakagua maelezo yako na kukuwasiliana hivi karibuni.",
    "problem_submitting": "Kulikuwa na tatizo katika kuwasilisha maombi yako. Tafadhali jaribu tena baadaye.",
    "become_driver": "Kuwa Dereva wa Uwasilishaji",
    "join_team": "Jiunge na timu yetu ya washirika wa uwasilishaji na upate pesa kwa ratiba yako mwenyewe!",
    "personal_information": "Maelezo ya Kibinafsi",
    "first_name": "Jina la Kwanza*",
    "last_name": "Jina la Mwisho*",
    "email_address": "Anwani ya Barua Pepe*",
    "phone_number": "Nambari ya Simu*",
    "phone_example": "mfano, +257 79 123456 au 79123456",
    "address_information": "Maelezo ya Anwani",
    "street_address": "Anwani ya Barabara*",
    "quartier_zone": "Quartier/Eneo*",
    "city": "Jiji*",
    "country": "Nchi*",
    "postal_code": "Msimbo wa Posta",
    "driver_information": "Maelezo ya Dereva",
    "drivers_license_number": "Nambari ya Leseni ya Kuendesha*",
    "vehicle_type": "Aina ya Gari*",
    "car": "Gari",
    "motorcycle": "Pikipiki",
    "bicycle": "Baiskeli",
    "scooter": "Skuta",
    "other": "Nyingine",
    "vehicle_make": "Muundo wa Gari*",
    "vehicle_make_example": "mfano, Toyota, Honda",
    "vehicle_model": "Muundo wa Gari*",
    "vehicle_model_example": "mfano, Camry, Civic",
    "vehicle_year": "Mwaka wa Gari*",
    "vehicle_year_example": "mfano, 2019",
    "availability_experience": "Upatikanaji na Uzoefu",
    "availability": "Upatikanaji*",
    "full_time": "Muda kamili",
    "part_time": "Muda wa sehemu",
    "weekends_only": "Wikendi tu",
    "evenings_only": "Jioni tu",
    "flexible_hours": "Masaa ya mabadiliko",
    "preferred_delivery_areas": "Maeneo ya Uwasilishaji Yanayopendekezwa",
    "delivery_areas_example": "mfano, Jiji la Kati, Upande wa Magharibi, Eneo la Kusini",
    "delivery_experience": "Uzoefu wa Uwasilishaji*",
    "no_experience": "Hakuna uzoefu wa awali",
    "less_than_1_year": "Chini ya mwaka 1",
    "1_2_years": "Mwaka 1-2",
    "3_5_years": "Mwaka 3-5",
    "5_plus_years": "Mwaka 5+",
    "additional_information": "Maelezo Zaidi",
    "upload_required_documents": "Pakua Nyaraka Zinazohitajika*",
    "all_3_documents": "Nyaraka zote 3 zinahitajika:",
    "max_file_size": "Ukubwa wa juu wa faili: 5MB kwa faili. Aina zinazokubalika: PDF, DOC, DOCX, JPG, PNG",
    "drivers_license_required": "1. Leseni ya Kuendesha*",
    "expiration_date": "Tarehe ya Mwisho*",
    "vehicle_insurance_required": "2. Cheti cha Bima ya Gari*",
    "vehicle_registration_required": "3. Nyaraka ya Usajili wa Gari*",
    "all_documents_uploaded": "Nyaraka zote zinazohitajika zimepakuliwa",
    "upload_all_documents": "Tafadhali pakua nyaraka zote zinazohitajika",
    "agree_background_check": "Nakubali ukaguzi wa nyuma*",
    "other_details": "Maelezo mengine yoyote unayotaka kushiriki",
    "submitting": "Inawasilisha...",
    "submit_application": "Wasilisha Maombi"
  },
  "orderTracking": {
    "order_tracking": "Kufuatilia Agizo",
    "order_number": "Agizo #",
    "current_status": "Hali ya Sasa",
    "estimated_delivery": "Uwasilishaji Unaokadiriwa",
    "driver_information": "Maelezo ya Dereva",
    "your_delivery_driver": "Dereva Wako wa Uwasilishaji",
    "driver_assigned": "Dereva amepewa kazi",
    "driver_not_assigned": "Maelezo ya dereva yataonekana mara tu atakapopewa kazi",
    "call_driver": "Mpigie Simu Dereva",
    "vehicle": "Gari",
    "live_tracking": "Kufuatilia Moja kwa Moja",
    "updating_route": "Inasasisha njia...",
    "estimated_arrival": "Kufika Kunaokadiriwa",
    "calculating": "Inahesabu...",
    "distance": "Umbali",
    "via_fastest_route": "kupitia njia ya haraka zaidi",
    "traffic": "Msongamano",
    "light_traffic": "Msongamano mwepesi",
    "moderate_traffic": "Msongamano wa wastani",
    "heavy_traffic": "Msongamano mkubwa",
    "checking_traffic": "Inakagua msongamano...",
    "loading_enhanced_map": "Inapakia ramani iliyoboreshwa...",
    "live_tracking_with_route": "Kufuatilia moja kwa moja na kuonyesha njia",
    "your_driver": "Dereva Wako",
    "delivery_location": "Mahali pa Uwasilishaji",
    "optimal_route": "Njia Bora",
    "last_location_update": "Sasisho la mwisho la mahali",
    "updates_every_30_seconds": "Sasisho kila sekunde 30",
    "route_summary": "Muhtasari wa Njia",
    "duration": "Muda",
    "min_delay": "dakika ya kuchelewa",
    "pickup_information": "Maelezo ya Kuchukua",
    "pickup_location": "Mahali pa Kuchukua",
    "pickup_instructions": "Maelekezo ya Kuchukua",
    "bring_valid_id": "Leta kitambulisho halali",
    "show_order_confirmation": "Onyesha uthibitisho wa agizo",
    "pay_at_pickup": "Lipa wakati wa kuchukua (ikiwa pesa wakati wa uwasilishaji)",
    "order_ready": "Agizo lako tayari!",
    "come_to_restaurant": "Tafadhali uje kwenye mgahawa ili kuchukua agizo lako.",
    "order_picked_up": "Agizo limechukuliwa kwa mafanikio!",
    "thank_you_service": "Asante kwa kutumia huduma yetu.",
    "status_updates": "Sasisho za Hali",
    "delivery_confirmation": "Uthibitisho wa Uwasilishaji",
    "refresh_tracking": "Onyesha Upya Kufuatilia",
    "real_time_updates_active": "Sasisho za wakati halisi zinafanya kazi",
    "real_time_updates_disconnected": "Sasisho za wakati halisi zimeondolewa",
    "last_updated": "Sasisho la mwisho",
    "arriving_now": "Inakuja sasa",
    "minute": "dakika",
    "minutes": "dakika",
    "hour": "saa",
    "hours": "masaa",
    "expected_shortly": "Inatarajiwa hivi karibuni",
    "calculating_eta": "Inahesabu...",
    "meters": "m",
    "kilometers": "km"
  }
}; 